import {LoggerService} from './logger.service';
import {ErrorHandler, Injectable} from '@angular/core';
import {LogLevel} from '../data/logLevel';
import {LogSource} from '../data/logSource';
import {LogSourceType} from '../data/logSourceType';
import {environment} from '../../../environments/environment';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  constructor(public loggerService: LoggerService) {
    this.loggerService = loggerService;
  }

  handleError(error: Error) {
    this.loggerService.logMessage(LogLevel.ERROR, LogSourceType.WEBKIT, LogSource.Console, error.name);
    this.loggerService.logMessage(LogLevel.DEBUG, LogSourceType.WEBKIT, LogSource.Console, error.stack);

    if (environment.env !== 'prod') {
      setTimeout(() => {
        throw error;
      });
    }
  }
}
